"use client";

import { useEffect, useState, type ReactNode } from "react";

/**
 * Renders children only after the component has mounted on the client.
 *
 * Use this to wrap purely decorative, non-deterministic UI (particles, binary
 * streams, randomized positions) so it is NOT server-rendered — avoiding React
 * hydration mismatches caused by `Math.random()` / `Date.now()` in render.
 */
export default function ClientOnly({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return mounted ? <>{children}</> : null;
}
